import React from "react";

export const FleshA = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none">
        <path
          d="M79.8495 50.4005C79.8495 49.1578 78.8422 48.1505 77.5995 48.1505L57.3495 48.1505C56.1069 48.1505 55.0995 49.1578 55.0995 50.4005C55.0995 51.6431 56.1069 52.6505 57.3495 52.6505L75.3495 52.6505L75.3495 70.6505C75.3495 71.8931 76.3569 72.9005 77.5995 72.9005C78.8422 72.9005 79.8495 71.8931 79.8495 70.6505L79.8495 50.4005ZM49.9072 78.0928L51.4982 79.6838L79.1905 51.9915L77.5995 50.4005L76.0085 48.8095L48.3162 76.5018L49.9072 78.0928Z"
          fill="white"
        />
        <circle
          cx="64"
          cy="64"
          r="42.7548"
          transform="rotate(-45 64 64)"
          stroke="white"
          stroke-width="5"
        />
      </svg>
    </div>
  );
};
